module.exports = __webpack_public_path__ + "img/SWE.1547048e.svg";